var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-vh-100 d-flex align-items-center",class:_vm.$style.bg},[_c('app-spinner',{class:_vm.$style.spinner}),_vm._v(" "),_c('nuxt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }